export type CurrencyTypes = `EUR` | `USD`;

export const currencyToSymbol = (currency?: CurrencyTypes) => {
  if (!currency) return ``;

  const settingsCurrency = [
    { code: `EUR`, symbol: `€` },
    { code: `USD`, symbol: `$` },
  ];
  const currencyFound = settingsCurrency.find((c: any) => c.code === currency);
  if (currencyFound) {
    return `${currencyFound.symbol}`;
  }
  return ``;
};

export const totalPriceWithDiscount = ({
  price,
  amountOff,
  percentOff,
}: {
  price: number;
  amountOff?: number;
  percentOff?: number;
}): number => {
  if (amountOff) {
    return +Math.max(price - amountOff, 0).toFixed(2);
  }
  if (percentOff) {
    return +Math.max(price - price * (percentOff / 100), 0).toFixed(2);
  }
  return price;
};
